import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericFormComponent } from 'src/app/shared/generic-form/generic-form.component';

@Component({
  selector: 'app-lezioni',
  templateUrl: './lezioni.component.html',
  styleUrls: ['./lezioni.component.scss'],
})
export class LezioniComponent implements OnInit {
  constructor(private router: Router, private modalService: NgbModal) {}

  ngOnInit(): void {}
  private isProcessing = false;
  slideSelected: number = 1;
  obiettiviSelected: number = 1;

  @ViewChild('myElement') myElement!: ElementRef; // Referenza all'elemento nel template
  @ViewChild('myElement2') myElement2!: ElementRef; // Referenza all'elemento nel template

  heroData = {
    title: 'Lezioni a scuola di coding e di didattica digitale',
    subtitle:
      'Sei un docente di una scuola primaria o secondaria e vuoi introdurre i tuoi studenti al coding e al pensiero computazionale? Easycode è la soluzione!',
    imgSrc: 'assets/img/Floppy_metodo.svg',
    class: 'floppy-platform',
  };

  coursesList: any = [
    {
      id: 1,
      name: 'Scratch',
      tag: 'T/E/M',
      img: 'assets/img/corsi/scratch.png',
      text: 'Crea cartoni animati, animazioni e storie interattive, quiz e puzzle, ma anche dei semplici giochi arcade.',
      url: '/scratch',
    },

    {
      id: 2,
      name: 'App Inventor',
      tag: 'T/E/M',
      img: 'assets/img/corsi/appInventor.png',
      text: 'è utilizzato per realizzare applicazioni Android. Consente di programmare senza scrivere codice.',
      url: '/app-inventor',
    },
    {
      id: 3,
      name: 'Robotica Educativa',
      tag: 'T/E/M',
      img: 'assets/img/corsi/robotica.png',
      text: 'Tramite la programmazione e lo sviluppo di un robot, si imparano le basi della programmazione.',
      url: '/robotica-educativa',
    },
  ];

  obiettiviList: any = [
    {
      id: 1,
      img: 'assets/img/puzzle.svg',
      text: 'Miglioramento della capacità di comunicare e lavorare in team per il raggiungimento di un obiettivo comune o di una soluzione condivisa (cooperative learning)',
    },

    {
      id: 2,
      img: 'assets/img/mon.svg',
      text: 'Sviluppo del pensiero computazionale e delle capacità logiche e di analisi',
    },
    
    {
      id: 3,
      img: 'assets/img/blend.svg',
      text: 'Favorire una didattica laboratoriale, basata sulla contaminazione di teoria e pratica',
    },
    {
      id: 4,
      img: 'assets/img/foglia.svg',
      text: 'Sviluppo di alcune importanti soft skills come: consapevolezza di sé; comunicazione efficace; pensiero creativo e critico; capacità di prendere decisioni',
    },

    {
      id: 5,
      img: 'assets/img/brain-circuit.svg',
      text: 'Promuovere l’apprendimento delle discipline STEM e delle competenze digitali',
    },
    
    {
      id: 6,
      img: 'assets/img/bot.svg',
      text: 'Trasmettere un approccio più sano alla tecnologia, rendendo bambini e ragazzi utenti attivi e consapevoli davanti allo schermo del proprio PC, tablet o smartphone',
    }
  ];

  ngAfterViewInit() {


    const element = this.myElement.nativeElement;
    const mc = new Hammer(element);

    const element2 = this.myElement2.nativeElement;
    const mc2 = new Hammer(element2);

    // Aggiungi i riconoscitori per gestire eventi specifici

    mc2.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.obiettiviSelected > 1) {
          this.obiettiviSelected--;
        } else {
          this.obiettiviSelected = 6;
        }
      } else if (ev.type === 'panleft') {
        if (this.obiettiviSelected < 6) {
          this.obiettiviSelected++;
        } else {
          this.obiettiviSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });

    mc.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.slideSelected > 1) {
          this.slideSelected--;
        } else {
          this.slideSelected = 3;
        }
      } else if (ev.type === 'panleft') {
        if (this.slideSelected < 3) {
          this.slideSelected++;
        } else {
          this.slideSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });
  }

  changeSlide(id: number) {
    this.slideSelected = id;
  }

  changeObiettivi(id: number) {
    this.obiettiviSelected = id;
  }

  openCourse(course: any) {
    this.router.navigateByUrl('/corsi' + course.url);
  }

  openModal(type: string) {
    const modalRef = this.modalService.open(GenericFormComponent, {
      size: 'lg',
      modalDialogClass: 'signup-modal',
      centered: true,
      
    });
    modalRef.componentInstance.type = type;
  }

}
